import { Notification } from "./Notification";

export class NoNotification extends Notification {
    constructor() {
        super();
    }

    notify() {
    }
}